/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaxStatus = {
    National: 'NATIONAL',
    International: 'INTERNATIONAL',
    NoStatus: 'NO_STATUS',
    EuropeReverseCharge: 'EUROPE_REVERSE_CHARGE',
    EuropeNoReverseCharge: 'EUROPE_NO_REVERSE_CHARGE'
} as const;
export type TaxStatus = typeof TaxStatus[keyof typeof TaxStatus];


export function instanceOfTaxStatus(value: any): boolean {
    for (const key in TaxStatus) {
        if (Object.prototype.hasOwnProperty.call(TaxStatus, key)) {
            // @ts-ignore
            if (TaxStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaxStatusFromJSON(json: any): TaxStatus {
    return TaxStatusFromJSONTyped(json, false);
}

export function TaxStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxStatus {
    return json as TaxStatus;
}

export function TaxStatusToJSON(value?: TaxStatus | null): any {
    return value as any;
}

